import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    private http = inject(HttpClient);

    constructor() { }

    get(): Observable<any> {
        return this.http.get(Global.url + 'V1/roles');
    }

    getById(id: any): Observable<any> {
        return this.http.get(Global.url + 'V1/roles/' + id);
    }

    create(data: any): Observable<any> {
        return this.http.post(Global.url + 'V1/roles', data);
    }

    update(id: any, data: any): Observable<any> {
        return this.http.put(Global.url + 'V1/roles/' + id, data);
    }

    delete(id: any): Observable<any> {
        return this.http.delete(Global.url + 'V1/roles/' + id);
    }

    saveMenusBulk(roleKey: any, menus: any[]): Observable<any> {
        return this.http.post(Global.url + 'V1/roles/menus/bulk', { roleId: roleKey, roleSlug: roleKey, menus });
    }
}
